export class ReturnReasonHelper {
  /** 取得退回假單原因 */
  static async getReturnReason(): Promise<any[]> {
    const resp = await fetch(`/service/return_reason/get_return_reason`);
    return resp.json();
  }
}
